import type { ChatUi } from '@voll-intelligence/genui-contract';
import type { GenUiEntry } from '../../shared/ui/registry.js';
import { supplierDisplayName } from '../shared/supplier_name.js';
import { MobilityOffersList } from './ui/mobility_offers.js';

export { MobilityOffersList } from './ui/mobility_offers.js';

/** Texto visível da seleção — carrega a posição só para a bolha do usuário. O
 *  agente NÃO resolve por esse texto: o `offerId` viaja estruturado (mobility-select). */
function pickText(offer: { title: string }, position: number): string {
  return `Quero escolher a opção ${String(position)} (${supplierDisplayName(offer.title)}).`;
}

/** Entrada de catálogo do `mobility_offers` (slot chat). "Escolher" vira um
 *  `mobility-select` com o `offerId` determinístico — o agente resolve
 *  `select_offer` por id, sem o LLM reinterpretar a posição. View-only
 *  (`readOnly` ou variante `collapsed`) usa sempre o deck colapsado. */
export const mobilityOffersEntry: GenUiEntry<Extract<ChatUi, { kind: 'mobility_offers' }>> = {
  kind: 'mobility_offers',
  slot: 'chat',
  policy: {
    productOf: () => 'mobility',
    // Variante colapsada (pós-seleção) congela para sempre nessa linha, mesmo
    // que a mensagem seja o turno ativo do agente.
    frozenWhen: (ui) => ui.variant === 'collapsed',
  },
  render: ({ ui, note, readOnly, dispatch }) => {
    const interactive = !readOnly && ui.variant !== 'collapsed';
    return (
      <MobilityOffersList
        offers={ui.offers}
        note={note}
        variant={ui.variant}
        selectedOfferId={ui.selectedOfferId}
        readOnly={readOnly}
        roundTrip={ui.roundTrip}
        distanceOverLimit={ui.distanceOverLimit}
        onSelect={
          interactive
            ? (offer, position) => {
                dispatch({
                  type: 'mobility-select',
                  offerId: offer.offerId,
                  ...(offer.price ? { price: offer.price } : {}),
                  text: pickText(offer, position),
                });
              }
            : undefined
        }
      />
    );
  },
};
